import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React from 'react';
import { css, styled } from 'styled-components';
import { resets, resetWithSelectors } from '../utils/index.js';

var buttonResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  display: inline-block;\n  max-width: 100%;\n  cursor: pointer;\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  display: inline-block;\n  max-width: 100%;\n  cursor: pointer;\n"])), resets.normalize.html, resets.normalize.button, resetWithSelectors([':-moz-focusring', '::-moz-focus-inner', '::-webkit-file-upload-button', '::-webkit-inner-spin-button', '::-webkit-outer-spin-button', "[type='button']", "[type='submit']"]), resets.common);
var Button = function Button(_a) {
  var forwardedRef = _a.forwardedRef,
    type = _a.type,
    passProps = __rest(_a, ["forwardedRef", "type"]);
  return /*#__PURE__*/React.createElement("button", __assign({}, passProps, {
    ref: forwardedRef,
    type: !!type ? type : 'button'
  }));
};
var HtmlButton = styled(Button).withConfig({
  componentId: "sc-104agys-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), buttonResets);
var templateObject_1, templateObject_2;

export { HtmlButton };
//# sourceMappingURL=HtmlButton.js.map
